/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-11-11 11:41:11
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-11-22 10:59:47
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorNavigation/Item/index.tsx
 */

import React from 'react';
import CountWords from '@/src/components/CountWords/CountWords';
import { DragNDropColumns, ItemWrapper } from '@/src/components';
import { Input } from '@/src/components/Antd';
import { Row, SectionContainer } from '@/src/components/Layouts';
import {
  EnumContainerStyle,
  EnumPosition,
} from '@/src/components/DragNDropColumns';
import LinkLibrary from '@/src/constrains/LinkLibrary';

function Item(props: any) {
  const {
    onTitleChange,
    onTitleLinkChange,
    onMenuTitleChange,
    onMenuLinkChange,
    onSort,
    onAdd,
    onDelete,
    errorProcessingProps,
    isOnPrimaryLanguage,
  } = props;

  return (
    <React.Fragment>
      <SectionContainer bottomBorder>
        <Row
          elements={[
            {
              child: (
                <ItemWrapper
                  title={'Title*'}
                  rightPart={
                    <CountWords allCount={100} count={props.title?.length} />
                  }>
                  <Input
                    error={
                      errorProcessingProps.specificError['titleError'] &&
                      errorProcessingProps.specificError['titleError']
                        .length !== 0
                    }
                    help={errorProcessingProps.specificError[
                      'titleError'
                    ]?.join('')}
                    size={'large'}
                    value={props.title}
                    onChange={onTitleChange.bind(null, props.uuid)}
                  />
                </ItemWrapper>
              ),
            },
            {
              child: isOnPrimaryLanguage ? (
                <ItemWrapper title={'Title Link'}>
                  <LinkLibrary
                    noBottomPadding
                    mode={'no-modal'}
                    error={errorProcessingProps.specificError[
                      'linkModuleError'
                    ]?.join('')}
                    title={''}
                    data={props.linkModule || {}}
                    onChange={onTitleLinkChange.bind(null, props.uuid)}
                    linkSet={{
                      scopeVariables: {
                        SalesChannelContent: props.contentUuid,
                      },
                    }}
                  />
                </ItemWrapper>
              ) : null,
            },
          ]}></Row>
      </SectionContainer>
      <SectionContainer>
        <DragNDropColumns
          hideTitle
          hideAdd={!isOnPrimaryLanguage}
          hideDrag={!isOnPrimaryLanguage}
          childGenerate={(_d, index) => (
            <Row
              elements={[
                {
                  child: (
                    <ItemWrapper
                      title={'Menu Item Title*'}
                      rightPart={
                        <CountWords allCount={100} count={_d.title?.length} />
                      }>
                      <Input
                        error={
                          errorProcessingProps.specificError[
                            `${_d.uuid}_titleError`
                          ] &&
                          errorProcessingProps.specificError[
                            `${_d.uuid}_titleError`
                          ]?.length !== 0
                        }
                        help={errorProcessingProps.specificError[
                          `${_d.uuid}_titleError`
                        ]?.join('')}
                        size={'large'}
                        value={_d.title}
                        onChange={onMenuTitleChange.bind(
                          null,
                          index,
                          props.uuid,
                        )}
                      />
                    </ItemWrapper>
                  ),
                },
                {
                  child: isOnPrimaryLanguage ? (
                    <ItemWrapper title={'Menu Item Link'}>
                      <LinkLibrary
                        noBottomPadding
                        mode={'no-modal'}
                        error={errorProcessingProps.specificError[
                          `${_d.uuid}_linkError`
                        ]?.join('')}
                        title={''}
                        data={_d.linkModule || {}}
                        onChange={onMenuLinkChange.bind(
                          null,
                          index,
                          props.uuid,
                        )}
                        linkSet={{
                          scopeVariables: {
                            SalesChannelContent: props.contentUuid,
                          },
                        }}
                      />
                    </ItemWrapper>
                  ) : null,
                },
              ]}></Row>
          )}
          onDelete={onDelete.bind(null, props.uuid)}
          data={
            Array.isArray(props.menuItems)
              ? props.menuItems.map((v) => ({
                  ...v,
                  draggableId: v.uuid,
                  hideDelete: !isOnPrimaryLanguage,
                }))
              : []
          }
          droppableId={props.uuid}
          onSort={onSort.bind(null, props.uuid)}
          onAdd={onAdd.bind(null, props.uuid)}
          addText='+ Add Menu item'
          dragContainerStyle={EnumContainerStyle.largeWithoutBkg}
          addTextPosition={EnumPosition.bottom}
          addContainerClassName={''}
          dragContainerClassName={''}
        />
      </SectionContainer>
    </React.Fragment>
  );
}

export default Item;
